import React, { useEffect, useState } from 'react';
import api from '../axios/api';
import { FaMapMarkerAlt, FaBuilding, FaBullseye, FaTag, FaClock, FaTrophy,FaSortNumericDown } from "react-icons/fa";
import { Tooltip } from 'react-tooltip';
import Loader from '../components/common/Loader';
import ReactLoading from 'react-loading';
// EventItem Component
const EventItem = ({ imageSrc, title, venue, duration, organizers, tags, targetSet, targetAchieved, details, project_id, esgGoals }) => {
  return (
    <div className="mb-8 rounded-xl border border-gray-200 overflow-hidden bg-white shadow-sm">

      {/* Full-width image */}
      <a rel="noreferrer" target="_blank" href={`/project/${project_id}`} className="block overflow-hidden">
        <img
          src={imageSrc || "assets/images/default-image.jpg"}
          alt={title}
          className="w-full h-auto"
          style={{ objectFit: "cover", display: "block" }}
        />
      </a>

      {/* Details — line by line */}
     <div className="px-4 py-1 flex flex-col">

        <a rel="noreferrer" target="_blank" href={`/project/${project_id}`}
          className="text-[15px] font-medium text-gray-900 truncate block hover:underline">
          {title}
        </a>



        {/* <div className="flex items-center gap-1.5 text-[13px]" style ={{overflow: 'hidden',textOverflow: 'ellipsis',whiteSpace: 'nowrap'}}>
          {details}
          <a rel="noreferrer" target="_blank" href={`/project/${project_id}`}
            className="ml-auto text-[12px] font-medium text-blue-700 whitespace-nowrap hover:underline shrink-0">
            View more info →
          </a>
        </div> */}

        {/* Venue — "View more info" pinned to right end */}
        <div className="flex items-center gap-1.5 text-[13px] min-w-0">
  <FaMapMarkerAlt className="text-[#3F6B33] shrink-0 text-[13px]" />
  
  <span className="font-medium text-gray-800 whitespace-nowrap">
    Venue:
  </span>

  <span className="text-gray-500 truncate flex-1">
    {venue}
  </span>

  <a
    rel="noreferrer"
    target="_blank"
    href={`/project/${project_id}`}
    className="text-[12px] font-medium text-blue-700 whitespace-nowrap hover:underline shrink-0"
  >
    View More
  </a>
</div>

        <div className="flex items-center gap-1.5 text-[13px]">
          <FaClock className="text-[#3F6B33] shrink-0 text-[13px]" />
          <span className="font-medium text-gray-800 whitespace-nowrap">Duration:</span>
          <span className="text-gray-500 truncate">{duration}</span>
        </div>

        <div className="flex items-center gap-1.5 text-[13px]">
          <FaBuilding className="text-[#3F6B33] shrink-0 text-[13px]" />
          <span className="font-medium text-gray-800 whitespace-nowrap">Organized by:</span>
          <span className="text-gray-500 truncate max-w-[260px]">{organizers}</span>
        </div>

        <div className="flex items-center gap-1.5 text-[13px]">
          <FaTag className="text-[#3F6B33] shrink-0 text-[13px]" />
          <span className="font-medium text-gray-800 whitespace-nowrap">Tags:</span>
          <span className="text-gray-500 truncate max-w-[300px]">{tags?.replaceAll(",", ", ")}</span>
        </div>

        <div className="flex items-center gap-1.5 text-[13px]">
          <FaBullseye className="text-[#3F6B33] shrink-0 text-[13px]" />
          <span className="font-medium text-gray-800 whitespace-nowrap">Target Set:</span>
          <span className="text-gray-500">{targetSet} Trees</span>
          <FaTrophy className="text-[#3F6B33] shrink-0 text-[13px] ml-2.5" />
          <span className="font-medium text-gray-800 whitespace-nowrap">Achieved:</span>
          <span className="text-gray-500">{targetAchieved} Trees</span>
        </div>

      </div>

      {/* SDG Goals — fills remaining space below details */}
      <div className="px-4 pb-3 flex flex-wrap items-center gap-1.5">
        <span className="text-[12px] font-extrabold text-gray-800 whitespace-nowrap mr-1">SDG Goals:</span>
        {esgGoals.split(",").map((goal) => (
          <img
            key={goal.trim()}
            src={`/images/EsgGoals/${goal.trim().replaceAll(" ", "-")}.jpg`}
            alt={goal.trim()}
            className="h-10 w-10 object-contain rounded shrink-0"
            data-tooltip-id="Esg-Goals"
            data-tooltip-content={goal.trim()}
          />
        ))}
        <Tooltip id="Esg-Goals" place="top" effect="solid" />
      </div>

    </div>
  );
};


const Projects = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetching data from the API
    api.get('/api/project/getallprojects')
      .then(response => {
        if (response.data.success) {
          setProjects(response.data.projects);
        }
        setLoading(false);
      })
      .catch(error => {
        console.error("There was an error fetching the projects!", error);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
        <ReactLoading type="spin" color="#8BC34A" height={50} width={50} />
        <div style={{ marginLeft: '20px' }}>
          <p>Loading projects...</p>
        </div>
      </div>
    );
  }

  return (
    <>
      {/* Page banner area */}
      <section className="bg-image pt-40 pb-40">
        <div className="container">
          <h2 className="wow fadeInUp">Plantation Projects</h2>
        </div>
      </section>

      {/* Event area */}
      <div className="event pt-20 pb-20">
        {/* <div className="p-10"> */}
        <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(600px, 1fr))",
            gap: "1.5rem",
            padding: "2rem",
          }}>
          {/* Loop through projects and render EventItem */}
          {projects.map((project) => (
            <EventItem
              key={project.project_id}
              project_id={project.project_id}
              imageSrc={project.project_cover_image}  // Fallback to default if null
              title={project.name}
              venue={project.address}
              duration={`${project.startDate} To ${project.endDate}`}
              organizers={project.organizationName}
              tags={project.tags}  // This might be multiple, modify if needed
              targetSet={project.target}
              targetAchieved={project.total_trees_planted}
              details={project.description}
              esgGoals={project.esgGoals}
              listing_order={project.listing_order}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default Projects;
